// Brand name shown in the shared strings that take {{brand}}.
const VARIANT = (process.env.REACT_APP_VARIANT || '').toLowerCase();

export const BRAND_NAME = VARIANT === 'urclyrd' ? 'Urclyrd' : 'Podesubir';
